import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { DataSnapResult, ArmaRestOrderList } from 'src/app/classes/json-interface';
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './dialogImport.component.html',
  styleUrls: ['./dialogImport.component.css']
})
export class DialogImportComponent implements OnInit {

  @ViewChild('inputFile', { static: true }) mInput!: ElementRef<HTMLInputElement>; // Ref sur le selecteur de fichier

  mSubjectFileData: Subject<any> = new Subject<any>(); // Déclencher lors qu'un fichier viens d'étre converti en tableau d'octet
  mFile?: File = undefined;  // Fichier a envoyer au server
  mInProgress: boolean = false;
  mCurrentSteelList: ArmaRestOrderList;

  constructor(public mHttp: HttpClient,
              public dialogRef: MatDialogRef<DialogImportComponent>,
              private mRouter: Router,
              private mDataService: DataService,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.mSubjectFileData.subscribe(next => { this.onFileReaded(next); });
    console.log('data', this.data);

    this.mCurrentSteelList = this.data;
  }

  ngOnInit() {
    this.mInput.nativeElement.click();
  }

  public validerDialog() {
    this.mInProgress = true;
    if (this.mFile)
      this.readFile(this.mFile);
  }

  public readFile(file: File) {
    const reader = new FileReader();
    // Préparation du callback lors de la lecture du fichier
    reader.onload = ev => {
      console.log('onload', this.mSubjectFileData);
      if (ev != null && ev.target != null)
        this.mSubjectFileData.next(ev.target.result);
    };

    reader.onprogress = (e) => {
      //console.log('onprogress', e);
    };
    reader.readAsArrayBuffer(file);
  }

  /**
   * Pour l'import du décorticagee
   * @param val ?
   */
  public async onFileReaded(val: ArrayBuffer) {
    console.log('onFileReaded', val);
    //new Int8Array(val)
    const arrayInt8 = new Uint8Array(val); // Uint8Array n'est pas reconu par datasnap, on repasse en array
    const array: number[] = [];
    for (const iterator of arrayInt8)
      array.push(iterator);
    const steelListCode = this.mCurrentSteelList.Code ? this.mCurrentSteelList.Code : -1;
    console.log('steelListCode', steelListCode);
    try {
      if (!this.mFile)
        return;
      const next = await ArmaServConnection.aPOST(this.mHttp, 'ImportAnalysis', array, [this.mFile.name, steelListCode]);
      const steelList = ((next as DataSnapResult).result[0] as ArmaRestOrderList);
      if (steelList) {
        this.mDataService.setInfoSteelList(steelList);
        this.mRouter.navigateByUrl('decorticage/' + steelList.Code);
        this.dialogRef.close();
      } else {
        console.error('steelList undefined', steelList);
      }
    } finally {
      this.mInProgress = false;
    }
  }

  public onFileChange(e: any) {
    try {
      if (this.mInput.nativeElement.files != null)
        this.mFile = this.mInput.nativeElement.files[0];
      //this.readFile(this.mFile);
    } catch (e) {
      console.error(e);
    }
  }

  get HTML_FileLoaded() {
    return this.mFile != undefined;
  }
}
